export const excelOnlineCourseFrontPageUrl = 'fi/excel-kurssi-netissa';
export const okBaseUrl = 'https://www.officekoulutus.fi/d';
// export const okBaseUrl = 'http://officekoulutus.local';
